import adminRoutes from './adminRoutes'; // 引入管理模块的路由配置



// 全部路由(包括baseroute，usermenu)
export default [
  {
    path: '/user',
    layout: false,
    routes: [
      { name: '登录', path: '/user/login', component: './User/Login' },
      { name: '注册', path: '/user/register', component: './User/Register' },
      { name: '修改密码', path: '/user/resetpassword', component: './User/ResetPassword' },
      { name: 'SSO登录', path: '/user/ssologin', component: './User/SSOLogin' },
      { name: 'UKey登录', path: '/user/uklogin', component: './User/UKeyLogin' }
    ],
  },
  { path: '/', redirect: '/dashboard' },
  { path: '*', layout: false, component: './404' },
  { path: '/403', layout: false, component: './403' },
  {
    name: '概览',
    icon: 'PieChartOutlined',
    path: '/dashboard',
    access: ['person', 'biz_annotator', 'biz_reviewer', 'biz_owner'],
    component: './Dashboard'
  },
  // {
  //   name: '任务概览',
  //   icon: 'LineChartOutlined',å
  //   path: '/taskdashboard',
  //   access: ['biz_owner'],
  //   component: './Dashboard/TaskDashboard',
  // },
  {
    name: '任务管理',
    icon: 'AppstoreAdd',
    path: '/task',
    access: ['biz_owner'],
    routes: [
      {
        path: '/task',
        name: '任务管理',
        icon: 'AppstoreAdd',
        component: './Task',
        hideInMenu: true,
      },
      {
        path: '/task/taskinfo',
        name: '任务信息',
        component: './Task/TaskInfo',
        hideInMenu: true,
      },
      {
        path: '/task/detail',
        name: '任务详情',
        component: './Task/Detail',
        hideInMenu: true,
      },
      { name: '查看层', path: '/task/viewLayer', component: './Datasets/ViewLayer', hideInMenu: true, },
      { name: '新建任务', path: '/task/create', component: './Task/CreateTask', hideInMenu: true, },
      { name: '查看层', path: '/task/viewLayer', component: './Datasets/ViewLayer', hideInMenu: true, },

    ],
  },
  {
    name: '数据集',
    icon: 'database',
    path: '/datasets',
    access: ['biz_owner', 'person'],
    routes: [
      { name: '数据集', icon: 'HddOutlined', path: '/datasets', component: './Datasets', hideInMenu: true, },
      { name: '新建数据集', path: '/datasets/create', component: './Datasets/CreateDataset', hideInMenu: true, },
      { name: '上传数据集', path: '/datasets/upload', component: './Datasets/DatasetUpload', hideInMenu: true, },
      { name: '数据详情', path: '/datasets/detail', component: './Datasets/Detail', hideInMenu: true, },
      { name: '导入轮廓标注', path: '/datasets/importannotaion', component: './Datasets/ImportAnnotaion', hideInMenu: true, },
      { name: '导入其他标注', path: '/datasets/importothersannotaion', component: './Datasets/ImportOthersAnnotaion', hideInMenu: true, },

      { name: '查看层', path: '/datasets/viewLayer', component: './Datasets/ViewLayer', hideInMenu: true, },
    ],
  },
  // { name: '标注', icon: 'ExportOutlined', path: '/annotation', access: ['biz_annotator'], component: './Task/TaskInfo', },
  {
    name: '标注',
    icon: 'ExportOutlined',
    path: '/annotation',
    access: ['biz_annotator'],
    routes: [
      {
        name: '标注',
        icon: 'ExportOutlined',
        path: '/annotation',
        access: ['biz_annotator'],
        component: './Task/TaskInfo',
        hideInMenu: true,
      },
      {
        name: '查看层',
        path: '/annotation/viewLayer',
        component: './Datasets/ViewLayer',
        hideInMenu: true,
      },
    ],
  },
  {
    name: '审核',
    icon: 'FileDoneOutlined',
    path: '/review',
    access: ['biz_reviewer'],
    routes: [
      {
        name: '审核',
        icon: 'ExportOutlined',
        path: '/review',
        access: ['biz_reviewer'],
        component: './Task/TaskInfo',
        hideInMenu: true,
      },
      {
        name: '查看层',
        path: '/review/viewLayer',
        component: './Datasets/ViewLayer',
        hideInMenu: true,
      },
    ],
  },
  {
    name: '仲裁',
    icon: 'FileSearchOutlined',
    path: '/arbitrate',
    access: ['biz_arbitrator'],
    routes: [
      {
        name: '仲裁',
        icon: 'ExportOutlined',
        path: '/arbitrate',
        access: ['biz_arbitrator'],
        component: './Task/TaskInfo',
        hideInMenu: true,
      },
    ],
  },
  {
    name: '抽审',
    icon: 'FileProtectOutlined',
    path: '/qualManage',
    access: ['biz_qualifier'],
    routes: [
      {
        name: '抽审',
        icon: 'ExportOutlined',
        path: '/qualManage',
        access: ['biz_qualifier'],
        component: './Task/TaskInfo',
        hideInMenu: true,
      },
    ],
  },
  {
    name: '帮助文档3',
    icon: 'FileTextOutlined',
    path: '/documents',
    component: './Documents',
    hideInMenu: true,
    layout: false,
  },
  {
    name: '个人中心',
    icon: 'user',
    path: '/personalcenter',
    component: './PersonalCenter',
    hideInMenu: true,
    layout: false,
  },
  {
    name: '系统管理',
    icon: 'user',
    path: '/admin',
    access: ['system', 'admin', 'tenant_admin'],
    component: './Admin',
    hideInMenu: true,
    layout: false,
    routes: adminRoutes, // 使用引入的路由配置
  },
  { name: 'AI模型', icon: 'ProductOutlined', path: '/aimodel', access: ['biz_owner', 'person'], component: './AIModel' },
  { name: '全量搜索', icon: 'SearchOutlined', path: '/search', access: ['person', 'biz_owner'], component: './GlobalSearch' },

  // { name: '传输日志', icon: 'CloudSyncOutlined', path: '/transferlog', access: ['person', 'biz_owner'], component: './TransferLog' },
  // { name: '导出数据', icon: 'ExportOutlined', path: '/exportdata', access: ['person', 'biz_owner'], component: './ExportData' },

];
